// @ts-nocheck
import useSWRMutation, { SWRMutationResponse } from "swr/mutation";
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";

const useWithdrawTransaction = (): SWRMutationResponse<any, Error> => {
  const httpClient: AxiosInstance = useHttpClient();
  return useSWRMutation(
    "withdraw-transaction",
    async (_key, { arg }: { arg: { amount: number, currency?: 'USDT' | 'IRT', wallet?: string, network: 'TRC20' | 'BEP20' } }): Promise<any> =>
      httpClient.post("/transactions/withdraw",
        {
          amount: arg.amount,
          currency: arg.currency || 'IRT',
          wallet: arg.wallet,
          network: arg.network
        }).then((res) => res.data.data)
  );
};

export default useWithdrawTransaction;
